/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module PositiveSecurityPolicyModule
 */

import { PositiveSecurityPolicy } from 'object-types';
import { AviPermissionResource } from 'generated-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

import { POSITIVE_SECURITY_POLICY_ITEM_TOKEN } from '../positive-security-policy.tokens';

/**
 * @description
 *     Positive Security Policy Collection class.
 * @author Zhiqian Liu
 */
export class PositiveSecurityPolicyCollection extends Collection {
    public static ajsDependencies = [
        POSITIVE_SECURITY_POLICY_ITEM_TOKEN,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'positivesecuritypolicy',
            windowElement: 'lazy-load',
            objectType: PositiveSecurityPolicy,
            permissionName: AviPermissionResource.PERMISSION_POSITIVESECURITYPOLICY,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getAjsDependency_(POSITIVE_SECURITY_POLICY_ITEM_TOKEN);
    }
}

/**
 * Type for PositiveSecurityPolicyCollection collection.
 */
export type TPositiveSecurityPolicyCollection = typeof PositiveSecurityPolicyCollection;
